/* eslint-disable import/prefer-default-export */
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type { SGRule } from '@src/endpoints/services/commonHdr.service'
import type { NetworkQueryResp_NetworkCountEntry } from '@src/endpoints/services/graphQueryMgr.service'
import type { SGRulesInfo } from '@src/redux/reducers/networks/networking'
import { forEach } from 'lodash'

export const getNetworkTotals = (
  network_count: NetworkQueryResp_NetworkCountEntry
) => ({
  [ResourceTypeEnum.VPC]: network_count[ResourceTypeEnum.VPC],
  [ResourceTypeEnum.SUBNET]: network_count[ResourceTypeEnum.SUBNET],
  [ResourceTypeEnum.ROUTE_TABLE]: network_count[ResourceTypeEnum.ROUTE_TABLE],
  [ResourceTypeEnum.SECURITY_GROUP]:
    network_count[ResourceTypeEnum.SECURITY_GROUP],
  [ResourceTypeEnum.INSTANCE]: network_count[ResourceTypeEnum.INSTANCE],
  ...network_count
})

export const formatSGRulesList = (result: SGRule[]) => {
  const rules: SGRulesInfo[] = []
  forEach(result || [], item => {
    let portNumbers = 'All'
    let protocol = 'All'
    if (item.ip_protocol && item.ip_protocol !== '-1') {
      protocol = item.ip_protocol
    }
    if (item.ports && item.ports[0] !== '0') {
      portNumbers = item.ports.join(', ')
    }
    rules.push({
      IPv4Range: item.ip_range ? item.ip_range.join(', ') : 'N/A',
      Description: 'Description',
      Protocol: protocol,
      IPv6Range: item.ipv6_range ? item.ipv6_range.join(', ') : 'N/A',
      Number: portNumbers,
      Direction: item.direction
    })
  })
  return rules
}
